/* eslint-disable react-hooks/exhaustive-deps */

import { removeNullAnalyticValues } from 'listing-details/helpers';
import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

import { trackPage } from 'shared/helpers/trackPage';

import { ListingContactPageTrackingProps } from './useListingContactPageTracking.types';

export const useListingContactPageTracking = (
    data: ListingContactPageTrackingProps,
    page: string,
    searchIdentifier: string | null
): void => {
    const ecommerce = {
        checkout: {
            products: [
                removeNullAnalyticValues(data.listing.analyticsEcommerce)
            ]
        }
    };

    const taxonomy = removeNullAnalyticValues({
        activity: 'listing_contact',
        page,
        url: data.listing.listingUris.contact,
        search_identifier: searchIdentifier,
        ...data.listing.analyticsTaxonomy
    });

    const client = useApolloClient();

    useEffect(() => {
        trackPage(page, taxonomy, ecommerce, client);
    }, [data.listing.analyticsTaxonomy.listingId]);
};
